<!--
 * @description: 维修--维修完成
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      :height="height"
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="RepairComplateSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>维修完成</div>
      </template>
      <template v-slot:tabelTitleRight>
        <delButton v-if="IsAdmin == 1" @buttonClick="delFun">删除</delButton>
        <downloadButton @buttonClick="exportAlls" style="margin-left: 10px"
          >导出</downloadButton
        >
        <!-- <el-button v-if="IsAdmin == 1" @Click="delFun" type="primary"
          >&nbsp; 删&nbsp;除&nbsp;
        </el-button> -->
        <!-- <el-button @Click="exportAlls" type="primary">
          &nbsp;导&nbsp;出&nbsp;
        </el-button> -->
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field labelText="品牌名称:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.BrandId"
              @change="handlePinP"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.pinP"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>

        <text-field labelText="产品类别:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.ProductId"
              clearable
              @change="handlechanPType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.chanPType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>

        <text-field labelText="产品型号:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.ModelNoId"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.chanPNum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>
        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.staetime"
          type="date"
          labelText="申请起始日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.endtime"
          type="date"
          labelText="申请截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.isfact"
          labelText="检索条件:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:goBackBtn="$opData">
        <div class="opration">
          <div class="style-aaa" @click="printClick($opData.data.row)">
            打印
          </div>
          <!-- <control-button
            class="item"
            @buttonClick="printClick($opData.data.row)"
            >打印</control-button
          > -->
        </div>
      </template> </tabel-panel
    >,

    <pop-dialog
      id="loadBOX"
      @confirmClick="popUploadClick"
      v-if="loadShow"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="loadShow = false"
    >
      <div class="oprationTree">
        <div class="detailed-box">
          <div class="detailed-title">维修明细</div>
          <el-tabs v-model="activeName" type="card" @tab-click="">
            <el-tab-pane label="客户信息" name="first">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.CompName"
                  labelText="客户名称:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.LinkMan"
                  labelText="联系人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="电话:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompCode"
                  labelText="手机:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.FaxNo"
                  labelText="传真:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Email"
                  labelText="Email:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.PostNo"
                  labelText="邮编:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Address"
                  labelText="地址:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="客户货运信息" name="second">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.CusTransferNo"
                  labelText="货运单号:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusTransferCompName"
                  labelText="货运公司:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusConveyanceName"
                  labelText="运输方法:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusTransferDate"
                  labelText="寄送时间:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.IllDesc"
                  labelText="备注:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="设备信息" name="third">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="RMA:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.BrandName"
                  labelText="品牌:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ProCateName"
                  labelText="产品:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ModelNoName"
                  labelText="型号:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="SN:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AttachName"
                  labelText="配件:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectDesc"
                  labelText="症状描述:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusApp"
                  labelText="症状信息:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="检测信息" name="fourth">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="RMA:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompName"
                  labelText="客户名称:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.LinkMan"
                  labelText="联系人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="电话:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.PostNo"
                  labelText="邮编:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.BrandName"
                  labelText="品牌:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ProCateName"
                  labelText="产品:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ModelNoName"
                  labelText="型号:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="SN:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AssignName"
                  labelText="请领人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.NotExpressName"
                  labelText="递送方式:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusApp"
                  labelText="症状信息:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AttachName"
                  labelText="附件:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectMan"
                  labelText="检测人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectDesc"
                  labelText="实际检测结果:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.IllDesc"
                  labelText="备注:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectDate"
                  labelText="检测日期:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.ActModelIllName"
                  labelText="实际症状类型:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="维修信息" name="fifth">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="合同:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactoryBackName"
                  labelText="返厂名称:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.MotoRMA"
                  labelText="MotoRMA:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FacRetDate"
                  labelText="返厂日期:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="是否返厂维修:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactoryPrice"
                  labelText="厂家报价:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactPriceDate"
                  labelText="厂家报价日期:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FacRetDate"
                  labelText="厂家返回日期:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactRepairMethod"
                  labelText="厂家维修方法:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ReciveDate"
                  labelText="接收日期:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusPrice"
                  labelText="给客户报价:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusPriceMethodName"
                  labelText="客户报价方式:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ModelNoName"
                  labelText="是否在保修期内:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.IsGiveUp"
                  labelText="是否放弃维修:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.RepairMan"
                  labelText="维修人:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.RepairDate"
                  labelText="维修日期:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.State"
                  labelText="状态:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.InternalRepairMethod"
                  labelText="维修方法:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Appendix"
                  labelText="备注:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="返回货运信息" name="sixth">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.TransferNo"
                  labelText="货运单号:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TransferCompName"
                  labelText="货运公司:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ConveyanceName"
                  labelText="运输方法:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TransferDate"
                  labelText="寄送时间:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.SerNote"
                  labelText="备注:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
          </el-tabs>
          <el-row class="bottomList" style="height: 300px">
            <el-col :span="24">
              <tabel-panel
                ref="tabelSNlist"
                style="height: 270px"
                :rowTemplate="tableCustomer"
                api="RepairComplateSearch"
                :condition="CustomerList"
                editType="pop"
                :showCondition="false"
                :autoSearch="true"
                :showCancelButton="false"
                :clickRowSelected="false"
                :popToCustomer="true"
              >
                <template v-slot:tabelTitleLeft>
                  <div style="padding-left: 10px">维修详细信息</div>
                </template>
                <template v-slot:goBackBtn="$opData">
                  <div class="opration">
                    <update-button
                      class="item"
                      @buttonClick="editTabelSN($opData.data.row)"
                    >
                    </update-button>
                  </div>
                </template>
              </tabel-panel>
            </el-col>
          </el-row>
          <div class="pop-dialogClose" @click="handleClick">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </pop-dialog>

    <pop-dialog
      id="printBOX"
      @confirmClick="popUploadClick"
      v-if="printShow"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="loadShow = false"
    >
      <div class="oprationTree">
        <div class="detailed-box">
          <div class="detailed-title">
            <control-button class="item" @buttonClick="printBtn"
              >打印</control-button
            >
          </div>
          <div id="printCons" class="printBoxWidth">
            <table style="width: 650px" cellspacing="0">
              <tbody>
                <tr style="width: 650px">
                  <td align="left">
                    <img
                      style="width: 160px; height: 90px"
                      src="../assets/images/light/comLogo.png"
                    />
                  </td>
                  <td align="right">
                    <font size="3" style="font-weight: bold"
                      >北京休恩博得科技发展有限公司</font
                    ><br />
                    <font size="2"
                      >北京海淀区马甸东路17号（金澳国际）1508室</font
                    ><br />
                    <font style="font-weight: bold" size="2"
                      >TEL:010-51660566</font
                    >
                    <font style="font-weight: bold" size="2"
                      >FAX:010-88579241</font
                    ><br />
                    <font size="2">http://www.shooin.com.cn </font>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: center">
                    <h2 style="font-size: 5ex">检测报告</h2>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" align="left">
                    <font style="font-weight: bold">送修公司</font><br />
                    <table class="currenttable">
                      <tbody>
                        <tr>
                          <td style="width: 100px; height: 25px">
                            送修公司名称
                          </td>
                          <td style="width: 350px">
                            {{ printRowData.CompName }}
                          </td>
                          <td style="width: 100px">送修日期</td>
                          <td style="width: 100px">
                            {{ printRowData.AddDate }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr style="height: 10px">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td colspan="2" align="left">
                    <font style="font-weight: bold" size="2">联系人信息</font
                    ><br />
                    <table style="width: 100%" class="currenttable">
                      <tbody>
                        <tr>
                          <td style="width: 100px; height: 25px">联系人信息</td>
                          <td>{{ printRowData.LinkMan }}</td>
                          <td style="width: 100px">手机</td>
                          <td>{{ printRowData.CompCode }}</td>
                        </tr>
                        <tr>
                          <td style="height: 25px">联系电话</td>
                          <td>{{ printRowData.TelNo }}</td>
                          <td>传真</td>
                          <td>{{ printRowData.FaxNo }}</td>
                        </tr>
                        <tr>
                          <td style="height: 25px">地址</td>
                          <td colspan="3">
                            {{ printRowData.Address }}
                          </td>
                        </tr>
                        <tr>
                          <td>邮编</td>
                          <td>{{ printRowData.PostNo }}</td>
                          <td style="height: 25px">Email</td>
                          <td>{{ printRowData.Email }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr style="height: 10px">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td colspan="2" align="left">
                    <font style="font-weight: bold" size="2">送修检测情况</font
                    ><br />
                    <table class="currenttable" style="width: 100%">
                      <tbody>
                        <tr>
                          <th style="height: 25px">型号</th>
                          <th>序列号</th>
                          <th>故障描述</th>
                          <th>附件描述</th>
                        </tr>
                        <tr class="tr">
                          <td style="width: 80px; height: 25px">
                            {{ printRowData.ModelNoName }}
                          </td>
                          <td style="width: 120px; height: 25px">
                            {{ printRowData.SerialNoName }}
                          </td>
                          <td style="width: 290px; height: 25px">
                            {{ printRowData.CusApp }}
                          </td>
                          <td style="width: 90px; height: 25px">
                            {{ printRowData.AttachName }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr style="height: 10px">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td colspan="2" align="left">
                    <font style="font-weight: bold" size="2">检测结果</font
                    ><br />
                    <table class="currenttable" style="width: 100%">
                      <tbody>
                        <tr class="trheade">
                          <th style="height: 25px">型号</th>
                          <th style="height: 25px">序列号</th>
                          <th style="width: 70px; height: 25px">解决办法</th>
                          <th style="width: 70px; height: 25px">检测信息</th>
                          <th>工程师</th>
                        </tr>
                        <tr class="tr">
                          <td style="width: 80px; height: 25px">
                            {{ printRowData.ModelNoName }}
                          </td>
                          <td style="width: 120px; height: 25px">
                            {{ printRowData.SerialNoName }}
                          </td>
                          <td style="width: 150px; height: 25px">
                            {{ printRowData.InternalRepairMethod }}
                          </td>
                          <td style="width: 150px; height: 25px">
                            {{ printRowData.DetectDesc }}
                          </td>
                          <td style="width: 180px; height: 25px">
                            {{ printRowData.AssignName }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr style="height: 20px">
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td style="text-align: left" colspan="2">
                    <font size="3" style="font-weight: bold"
                      >{{ printRowData.CompName }} </font
                    ><br />
                    <font size="2">邮编：{{ printRowData.PostNo }}</font
                    ><br />
                    <font style="font-weight: bold" size="2"
                      >联系人：{{ printRowData.LinkMan }}</font
                    ><br />
                    <font style="font-weight: bold" size="2"
                      >Email：{{ printRowData.Email }}</font
                    ><br />
                    <font size="2"
                      >TEL: {{ printRowData.TelNo }}&nbsp;&nbsp;</font
                    >
                    <font size="2">FAX: {{ printRowData.TelNo }}</font>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pop-dialogClose" @click="handleClickClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </pop-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import controlButton from "@/components/controlButton.vue";
import downloadButton from "@/components/downloadButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { RepairProductCancel } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import printJS from "print-js";
import { downloadExcel } from "@/util/download.js";
import { ElMessageBox } from "element-plus";

export default {
  name: "RepairComplate",
  components: {
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
    downloadButton,
    controlButton,
  },
  data() {
    const selectRemoteSearchData = async (
      pageSize,
      currentPageIndex,
      parms
    ) => {
      if (parms.ProductId == null || parms == null) {
        return {
          total: 0,
          data: null,
        };
      }
      let source = await tableApi.modelSelect({
        ProductCategoryId: parms.ProductId,
      });
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    return {
      IsAdmin: "",

      options: {
        pinP: [],
        chanPType: [],
        chanPNum: [],
      },
      conditionData: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
        staetime: null,
        endtime: null,
        isfact: null,
      },
      inputValue: "明细",
      activeName: "second",
      printShow: false,
      loadShow: false,
      rowData: null,
      rowTemplate: [
        {
          columnType: "check",
          width: "80",
        },
        {
          headerLabel: "公司名称",
          width: 100,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "维修人",
          width: 80,
          sortable: true,
          dataIndex: "DetectMan",
        },
        {
          headerLabel: "维修状态",
          width: 100,
          sortable: true,
          dataIndex: "State",
        },
        {
          headerLabel: "递送方式",
          width: 180,
          sortable: true,
          dataIndex: "NotExpressName",
        },
        {
          headerLabel: "产品",
          width: 80,
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          width: 180,
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN号",
          width: 160,
          sortable: true,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1 ? "red" : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "附件",
          width: 60,
          dataIndex: "AttachName",
        },
        {
          headerLabel: "实际检测结果", //0
          width: 120,
          dataIndex: "DetectDesc",
        },
        {
          headerLabel: "维修中心",
          sortable: true,
          width: 100,
          dataIndex: "ServerName",
        },
        {
          headerLabel: "完成日期",
          sortable: true,
          width: 120,
          dataIndex: "RepairDate",
        },
        {
          headerLabel: "接收日期",
          sortable: true,
          width: 120,
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "寄送日期",
          sortable: true,
          width: 120,
          dataIndex: "TranDate",
        },
        {
          headerLabel: "返回日期",
          sortable: true,
          width: 120,
          dataIndex: "FacRetDate",
        },
        {
          headerLabel: "维修周期",
          sortable: true,
          width: 120,
          dataIndex: "Repairdays",
        },
        {
          headerLabel: "打印",
          slot: "goBackBtn",
          width: "50",
          fixed: "right",
        },
      ],
      height: "400",

      // 维修记录
      tableCustomer: [
        {
          headerLabel: "接收日期",
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "实际检测结果",
          dataIndex: "DetectDesc",
        },
        {
          headerLabel: "维修方法",
          dataIndex: "FactRepairMethod",
        },
        {
          headerLabel: "附件",
          dataIndex: "AttachName",
        },
        {
          headerLabel: "维修中心",
          dataIndex: "ServerName",
        },
        {
          headerLabel: "请领人",
          dataIndex: "AssignName",
        },
        {
          headerLabel: "维修周期",
          dataIndex: "RepairCycle",
        },
        {
          headerLabel: "保修",
          dataIndex: "IsWarranty",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "返厂", //0
          dataIndex: "IsReturnFact",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "放弃",
          dataIndex: "IsGiveUp",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
      ],
      // 维修记录查询条件
      CustomerList: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
        staetime: null,
        endtime: null,
        rma: null,
        isfact: null,
      },
      printRowData: null,
      selectChildData: null,
      selectChildMoid: null,
    };
  },
  updated() {
    const keys = Object.keys(this.conditionData);
    keys.forEach((item) => {
      this.conditionData[item] = null;
    });
  },
  mounted() {
    this.IsAdmin = JSON.parse(localStorage.getItem("del_yes_or_no"));
    // debugger
    this.getPinPData();
  },
  methods: {
    // 有权限的删除按钮
    delFun() {
      let sels = this.$refs.tabel.getSelection();
      if (sels.length == 0) {
        errMsg("至少选择一行数据");
        return;
      }
      let ids = sels.map((m) => m.Id * 1);

      console.log("ids--", ids);
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log(tableApi.RepairComplateDelete,'RepairComplateDelete')
          tableApi.RepairComplateDelete(ids).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    // 获取品牌名称数据
    async getPinPData() {
      let {
        data: { list },
      } = await tableApi.BrandSelect();

      this.options.pinP = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlePinP(v) {
      this.options.chanPType = [];
      this.options.chanPNum = [];
      this.conditionData.ProductId = "";
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.ProductSelect({ Bid: v });
      this.options.chanPType = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlechanPType(v) {
      this.options.chanPNum = [];
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.modelSelect({ ProductCategoryId: v });
      this.options.chanPNum = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    // 客户名称数据
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动一级数据
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动二级数据
     * @param {*} Bid---一级数据id
     * @return {*}
     */
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动三级数据
     * @param {*} ProductCategoryId--二级数据id
     * @return {*}
     */
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildMoid == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 重新加载表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    /*  delSingleUser({ row }) {
       let id = row.Id;
       RepairProductCancel({ id }).then((data) => {
         if (data.code == 0) {
           successMsg(data.message);
           this.reloadData();
         } else {
           errMsg(data.message);
         }
       });
     }, */
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    /**
     * @description: 双击某行
     * @param {*} row
     * @return {*}
     */
    customerRowDblClick(row) {
      console.log("row:", row);
      this.loadShow = true;
      this.rowData = row;
      this.CustomerList.sn = row.SerialNoName;
      console.log("row:", this.rowData);
    },
    // 表格打印按钮
    printClick(row) {
      console.log("row:", row);
      this.printShow = true;
      this.printRowData = row;
      console.log("row2:", this.printRowData);
    },
    handleClick(tab, event) {
      this.loadShow = false;
    },
    // 关闭弹出框
    handleClickClose() {
      this.printShow = false;
    },
    // 弹出框打印按钮
    printBtn() {
      // console.log("打印");
      printJS({
        printable: "printCons",
        type: "html",
        ignoreElements: ["no-print", "bc", "gb"],
      });
    },
    // 导出
    exportAlls() {
      tableApi
        .RepairComplateDaoChu({
          page: 1,
          limit: 20,
          ...this.conditionData,
        })
        .then((data) => {
          downloadExcel(data, "维修完成");
        });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  #loadBOX {
    width: 100%;
    height: 100%;
  }

  .pop-dialog-conver {
    background: yellow;
  }

  .oprationTree {
    background-color: #ecf5ff;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 25px 20px 15px 20px;

    .detailed-box {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #99bce8;
      background-color: #f4f7f6;
      border-radius: 10px;
      overflow: auto;

      .detailed-title {
        // position:absolute;
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 10px 20px;
        width: 320px;
      }

      .user-management-container .condition-container-input {
        margin: 5px 10px;
      }

      .pop-dialogClose {
        position: absolute;
        top: 20px;
        right: 15px;

        .el-icon-close:before {
          font-size: 28px;
        }

        .el-icon-close:hover {
          color: #f92323;
        }
      }
    }
  }

  .pop-dialog-conver {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }

  .el-input.is-disabled .el-input__inner {
    color: #333333;
  }

  .grid-content {
    text-align: center;
    border: 1px solid black;
  }

  .printBoxWidth {
    padding: 0 28%;
    padding-top: 18px;
  }

  .p-height {
    margin: 15px 0 2px;
  }

  .pop-dialog-body {
    .detailed-box {
      .bottomList {
        position: absolute;
        width: 100%;
        bottom: 10px;
      }
    }
  }

  // #printCons table tr th, table tr td { border:1px solid #000000; }
  // table {text-align: center; border-collapse: collapse; border:0;}
  #printCons .currenttable {
    border-collapse: collapse;
    border: solid black;
    border-width: 1px 1px 1px 1px;
  }

  .currenttable tr td {
    font-size: small;
    text-align: left;
    background-color: White;
    border: solid black;
    border-width: 0 1px 1px 1px;
  }

  .currenttable th {
    text-align: center;
    background-color: White;
    border: solid black;
    border-width: 0px 1px 1px 1px;
  }
}

::v-deep .el-table__body-wrapper {
  // overflow: auto !important;
  // // color:red !important;
  // height: 85% !important;
}

::v-deep .el-select-dropdown__item {
  padding: auto auto;
}
::v-deep .pop-dialog-container {
  transform: none !important;
}
.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
